module.exports = __webpack_public_path__ + "img/faq-question-icon.42b699b8.svg";